<template>
    <div class="inventory_warehouse_management_wrap">
        <div class="inventory_warehouse_management_left">
            <ul>
                <li class="custom_hover_active_class  font_bold" :class="{'active':warehouseId == 0}" @click="handleClickWarehouse({id:0,name:''})">
                    <p>全部产品</p>
                    <el-tooltip class="item" effect="dark" content="添加仓库" placement="top">
                        <span @click="handleClickAddWarehouse()" class="handle_icon_wrap"><i class="el-icon-circle-plus-outline"></i></span>
                    </el-tooltip>
                </li>
                <li v-for="item in warehouseList" class="custom_hover_active_class  font_bold" :class="{'active':warehouseId == item.id}"  @click.stop="handleClickWarehouse(item)">
                    <p class="ellipsis" >
                        <EllipsisTooltip :text="item.name" />
                    </p>
                    <el-dropdown  placement="bottom-end" size="small" trigger="click" @click.stop>
                        <span class="icon_wrap" @click.stop> <i class="el-icon-more"></i></span>
                        <el-dropdown-menu class="treeDropDown" slot="dropdown">
                            <el-dropdown-item @click.native="handleClickEditWarehouse(item)">编辑</el-dropdown-item>
                            <el-dropdown-item @click.native="handleClickDelWarehouse(item)">删除</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </li>
            </ul>
        </div>

        <div class="inventory_warehouse_management_right">
            <div class="inventory_warehouse_management_search_handle">
                <div class="inventory_warehouse_management_search">
                    <el-input size="small" v-model="keywords" placeholder="请输入需要查询的内容"  clearable  @clear="handleClickSearch"  @keyup.enter.native="handleClickSearch">
                        <i slot="suffix" class="el-icon-search" @click="handleClickSearch"></i>
                    </el-input>
                </div>
                <div class="inventory_warehouse_management_handle">
                    <div class="custom_dropdown">
                        <el-dropdown  trigger="click" >
                            <el-button size="small">更多<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item class="warehouse_dropdown_item" @click.native="handleClickImport()" >导入</el-dropdown-item>
                                <el-dropdown-item class="warehouse_dropdown_item" @click.native="handleClickExport()">导出</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <el-button v-if="warehouseId" type="primary" plain size="small" @click="handleClickTransfer()">转移</el-button>
                    <el-button  v-if="pagination.total != 0" type="primary" size="small" @click="handleClickOut()">出库</el-button>
                    <el-button disabled class="is-disabled" size="small" v-if="pagination.total == 0">出库</el-button>
                    <el-button  type="primary" size="small" @click="handleClickIn()">入库</el-button>
                </div>
            </div>
            <div class="inventory_warehouse_management_table">
                <CustomVxeTable
                        :loading="loading"
                        ref="tableRef"
                        class="custom-table"
                        id="warehouseTable"
                        :autoResize="true"
                        :tableData="tableData"
                        :reduceHeight="reduceHeight"
                        :isShowToolBar="true"
                        :empty-render="{ name: 'NotData' }"
                        :pagination.sync="pagination"
                        @handleCurrentChange="handleCurrentChange"
                        @handleSizeChange="handleSizeChange"
                        :customConfig="tableCustomConfig"
                        :rowId="'id'"
                        :checkboxConfig="{reserve:true}"
                        @checkbox-all="handleSelectionChange"
                        @checkbox-change="handleSelectionChange">
                    <vxe-column fixed="left" field="checkbox" type="checkbox" width="42" ></vxe-column>
                    <vxe-column field="name" title="产品名称"  min-width="184" show-overflow>
                        <template #default="{ row }">
                            <span class="link-label"  @click="handleClickRowDetails(row)" v-text="row.name"></span>
                        </template>
                    </vxe-column>
                    <vxe-column field="stock_id" title="所属仓库"  min-width="180" show-overflow>
                        <template #default="{ row }">
                            <span  v-text="row.stocks ? row.stocks.name : ''"></span>
                        </template>
                    </vxe-column>
                    <vxe-column field="total_num" title="库存数量"  width="142" show-overflow></vxe-column>
                    <vxe-column field="operate" width="90" fixed="right">
                        <template #header>
                            <span>操作</span>
                            <el-tooltip class="item" effect="dark" content="表头设置" placement="bottom-start">
                                <i class="iconfont icon-biaotoushezhi table-header-icon" @click="handleClickCustom"></i>
                            </el-tooltip>
                        </template>
                        <template #default="{ row }">
                            <div class="table-operate-icon">
                                <el-dropdown  placement="bottom-end" size="small" trigger="click">
                                    <span class="icon_wrap"> <i class="el-icon-more"></i></span>
                                    <el-dropdown-menu class="treeDropDown" slot="dropdown">
                                        <el-dropdown-item @click.native="handleClickRowIn(row)">入库</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickRowOut(row)">出库</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickRowTransfer(row)">转移</el-dropdown-item>
                                        <el-dropdown-item @click.native="handleClickRowDetails(row)">详情</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </div>
                        </template>
                    </vxe-column>
                    <template #empty>
                        <div class="custom-table-empty">
                            <template v-if="keywords">
                                <div class="custom-table-empty-img">
                                    <img src="https://download.hecoos.com/enlightv/2025-09/396f6b4018a1fa0cb9cbaa6696b8b68f.png" alt="">
                                </div>
                                <p class="custom-table-empty-txt">暂无搜索结果，请重新输入</p>
                            </template>
                            <template v-else>
                                <div class="custom-table-empty-img">
                                    <img src="https://download.hecoos.com/enlightv/2024-53/147a907c1ec9fd000d8e8b0b30dd0fba.svg" alt="">
                                </div>
                                <p class="custom-table-empty-txt">暂无产品，请先入库或导入产品</p>
                                <div class="mt_16">
                                    <el-button v-if="pagination.total != 0" type="primary" plain size="small" @click="handleClickOut()">出库</el-button>
                                    <el-button type="primary" plain size="small"  @click="handleClickIn()">入库</el-button>
                                    <el-button v-if="pagination.total == 0" type="primary" plain size="small" @click="handleClickImport">导入</el-button>
                                </div>
                            </template>

                        </div>
                    </template>

                </CustomVxeTable>
            </div>
        </div>

        <WarehouseTpl :warehouseTplDialog.sync="warehouseTplDialog" :warehouseEditId="warehouseEditId" @success="getStockList"  v-if="warehouseTplDialog"/>
        <ProductTransfer :productTransferDialog.sync="productTransferDialog" :transferProductData="productInfo ? [productInfo] : selectedList" :warehouseId="transferStockId" :warehouseName="transferStockName" @success="handleClickSearch" v-if="productTransferDialog"/>
        <ProductDetail :productDetailDialog.sync="productDetailDialog" :productInfo="productInfo" v-if="productDetailDialog"/>
    </div>
</template>

<script>
import {stockList,stockDel,stockProductList,stockProductExport} from "@/api"
import {pagination} from "@/mixins";
import CustomVxeTable from "@/components/pComponents/vxe-table";
import WarehouseTpl from "./component/warehouse_tpl.vue";
import ProductTransfer from "./component/product_transfer.vue";
import ProductDetail from "./component/product_detail"
import EllipsisTooltip from '@/components/pComponents/ellipsisTooltip';
import XLSX from 'xlsx';
import {EventBus} from '@/utils/eventBus';
export default {
    name: "WarehouseManagement",
    components: {
        CustomVxeTable,
        WarehouseTpl,
        ProductTransfer,
        ProductDetail,
        EllipsisTooltip
    },
    data() {
        return {
            loading:false,
            warehouseId:0,
            warehouseName:'',
            warehouseList:[],
            keywords:'',
            tableData:[],
            tableHeight:'',
            tableCustomConfig: {
                storage:true,
                allowFixed: false,
                confirmButtonText: "确定",
                resetButtonText: "重置",
                visibleMethod: (col) => {
                    return true;
                },
                checkMethod: (col) => {
                    return col.column.field !== "checkbox";
                },
                allowSort: true,
            },
            selectedList:[],//选中
            warehouseTplDialog:false,
            warehouseEditId:0,

            productTransferDialog:false,

            productDetailDialog:false,
            productInfo:null,
            transferStockId:0,
            transferStockName:'',
            outDisabled:false
        };
    },
    mixins: [pagination],
    computed: {
        reduceHeight() {
            return  this.tableData.length ? 170 : 124;
        },
    },
    created() {
        this.getStockList()
        this.getTableData()
        EventBus.$on('inventoryInUpdated', this.handleClickSearch);
        EventBus.$on('inventoryOutUpdated', this.handleClickSearch);
    },
    beforeDestroy() {
        EventBus.$on('inventoryInUpdated', this.handleClickSearch);
        EventBus.$on('inventoryOutUpdated', this.handleClickSearch);
    },
    mounted() {

    },
    methods: {
        // 导入
        handleClickImport(){
            this.$router.push({
                name: "WarehouseImport",
                params: {
                    isPush: true,
                },
                query: { },
            });
        },
        // 导出
        handleClickExport(){
            if(this.selectedList.length){
                this.xlsxToExcel(this.selectedList)
            }else{
                this.loading = true
                let postData = {
                    page: 1,
                    pageSize: this.pagination.total,
                    id:this.warehouseId ? this.warehouseId : '',
                    keyword:this.keywords
                }
                this.loading = true
                stockProductList(postData).then(res => {
                    if (res.code === 200) {
                        let {list,total} = res.data
                       this.xlsxToExcel(list)
                    }
                    this.loading = false
                })
            }
        },
        xlsxToExcel(exportData) {
            const tableData = []
            let fields_list = [
                {field_key: "name",field_name: "产品名称"},
                {field_key: "stock_name",field_name: "所属仓库"},
                {field_key: "total_num",field_name: "数量"},
            ]
            let dataInfo = []
            exportData.forEach((item,key)=>{
                let json = {
                    name:item.name,
                    stock_name:item.stocks.name,
                    total_num:item.total_num
                }
                dataInfo.push(json)
            })

            dataInfo.forEach(item => {
                const data = {}
                for (const itemKey in item) {
                    if (fields_list.find(item => item.field_key === itemKey)) {
                        const row = fields_list.find(item => item.field_key === itemKey)
                        data[row.field_name] = item[itemKey]
                    }
                }
                tableData.push(data)
            })
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(tableData);
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const fileName = this.nowDate()
            XLSX.writeFile(wb, fileName);
        },
        nowDate() {
            const today = new Date();
            const year = today.getFullYear();
            const month = today.getMonth() + 1;
            const date = today.getDate() < 10 ? '0' + today.getDate() : today.getDate();
            const hours = today.getHours();
            const minutes = today.getMinutes();
            const seconds = today.getSeconds() < 10 ? '0' + today.getSeconds() : today.getSeconds()
            return `仓库管理${year}年${month}月${date}日${hours}时${minutes}分${seconds}秒.xlsx`;
        },
        // 转移
        handleClickTransfer(){
            this.transferStockId = this.warehouseId
            this.transferStockName = this.warehouseName
            this.productInfo = null
            this.productTransferDialog = true
        } ,
        // 出库
        handleClickOut(){
            let selectedList = JSON.parse(JSON.stringify(this.selectedList))
            if(!this.warehouseId){
                selectedList.forEach((item)=>{
                    item.stock_id = ''
                })
            }
            this.$store.dispatch("inventoryProductData", selectedList);
            this.selectedList = []
            this.$refs.tableRef.removeCheckboxRow()
            this.$router.push({
                name: 'OutWarehouseAdd',
                query:{

                },
                params: {
                    from:"warehouse",
                    isPush: true
                }
            })
        },
        // 入库
        handleClickIn(){
            let selectedList = JSON.parse(JSON.stringify(this.selectedList))
            if(!this.warehouseId){
                selectedList.forEach((item)=>{
                    item.stock_id = ''
                })
            }
            this.$store.dispatch("inventoryProductData", selectedList);
            this.selectedList = []
            this.$refs.tableRef.removeCheckboxRow()
            this.$router.push({
                name: 'InWarehouseAdd',
                query:{

                },
                params: {
                    from:"warehouse",
                    isPush: true
                }
            })
        },
        // 新增仓库
        handleClickAddWarehouse(){
            this.warehouseEditId = 0
            this.warehouseTplDialog = true
        },
        // 点击仓库
        handleClickWarehouse(item){
            this.warehouseId = item.id
            this.warehouseName = item.name
            this.selectedList = []
            this.$refs.tableRef.removeCheckboxRow()
            this.handleClickSearch()
        },
        // 编辑仓库
        handleClickEditWarehouse(item){
            this.warehouseEditId = item.id
            this.warehouseTplDialog = true
        },
        // 删除仓库
        handleClickDelWarehouse(item){
            const h = this.$createElement;
            let isDelete = item.haveProduct
            let title = isDelete ? '当前选择仓库内存在产品，不可删除仓库，请先转移产品后重试。' : '是否删除当前选择仓库，删除后不可恢复，谨慎操作。'
            this.$msgbox({
                title: '删除仓库',
                message: h('div', null, [
                    h('span', null, title),
                ]),
                iconClass: `icon-jinggao iconfont prompt_message_icon ${isDelete ? 'status1' : 'status0'}`,
                customClass: 'prompt_message_custom',
                confirmButtonText:  isDelete ? '知道了' : '删除',
                closeOnClickModal: false,
                closeOnPressEscape: false,
                showCancelButton: !isDelete,
                confirmButtonClass: !isDelete ? 'el-button--danger danger' : 'el-button--primary',
                beforeClose: (action, instance, done) => {
                    if (action === 'confirm') {
                        done();
                    } else {
                        done();
                    }
                }
            }).then(() => {
                if(isDelete){return false}
                stockDel({id:item.id}).then(res=> {
                    if(res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '删除成功'
                        });
                        this.getStockList()
                    }
                })

            }).catch(() => {

            })
        },
        // 搜索
        handleClickSearch(){
            this.pagination.pageNum = 1
            this.getTableData()
        },

        // 表头配置
        handleClickCustom() {
            this.$refs.tableRef.handleOpenCustomShow();
        },
        handleSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableData()
        },
        handleCurrentChange(val) {
            this.pagination.pageNum = val
            this.getTableData()
        },
        // 获取仓库列表
        getStockList(){
            stockList({}).then(res => {
                if (res.code === 200) {
                    this.warehouseList = res.data
                }
            })
        },
        getTableData(){
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                id:this.warehouseId ? this.warehouseId : '',
                keyword:this.keywords
            }
            this.loading = true
            stockProductList(postData).then(res => {
                if (res.code === 200) {
                    let {list,total} = res.data
                    if(!this.warehouseId && !this.keywords && list.length == 0 && this.pagination.pageNum == 1){
                        this.outDisabled = true
                    }
                    this.tableData = list
                    this.pagination.total = total
                }
                this.loading = false
            })
        },
        // 表格复选框
        handleSelectionChange({ records, reserves }) {
            this.selectedList =  [...reserves, ...records]
        },
        // 单个入库
        handleClickRowIn(row){
            let data = JSON.parse(JSON.stringify(row))
            if(!this.warehouseId){
                data.stock_id = ''
            }
            this.$store.dispatch("inventoryProductData", [data]);
            this.$router.push({
                name: 'InWarehouseAdd',
                query:{},
                params: {
                    from:"warehouse",
                    isPush: true
                }
            })
        },
        // 单个出库
        handleClickRowOut(row){
            let data = JSON.parse(JSON.stringify(row))
            if(!this.warehouseId){
                data.stock_id = ''
            }
            this.$store.dispatch("inventoryProductData", [data]);
            this.$router.push({
                name: 'OutWarehouseAdd',
                query:{},
                params: {
                    from:"warehouse",
                    isPush: true
                }
            })
        },
        // 单个转移
        handleClickRowTransfer(row){
            this.transferStockId = row.stocks.id
            this.transferStockName = row.stocks.name
            this.productInfo = row
            this.productTransferDialog = true
        },
        // 详情
        handleClickRowDetails(row){
            this.productInfo = row
            this.productDetailDialog = true
        },
    },
}
</script>

<style  lang="scss" scoped>
    @import "@/styles/inventory_management.scss";
    .el-popper{
        margin-top: 2px;
    }
    ::v-deep .vxe-table-custom--panel-list>li.is--hidden{
        display: none;
    }
</style>